import { api } from '../lib/api';
import type { PlatformDefaults } from '../types/api';

export async function getPlatformDefaults(): Promise<PlatformDefaults> {
  const { data } = await api.get<PlatformDefaults>('/admin/platform-defaults');
  return data;
}

export async function updatePlatformDefaults(defaultVatRate: number): Promise<PlatformDefaults> {
  const { data } = await api.patch<PlatformDefaults>('/admin/platform-defaults', { defaultVatRate });
  return data;
}
